import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import React from 'react';
import css from './index.module.scss';

const TC: React.FC = () => {
    const { t } = useLang('TrailSeries.TC');

    const items = [
        {
            title: t('title'),
        },
        {
            title: t('title1'),
        },
        {
            title: t('title2'),
        },
        {
            title: t('title3'),
        },
        {
            title: t('title4'),
        },
        {
            title: t('title5'),
        },
        {
            title: t('title6'),
        },
        {
            title: t('title7'),
        },
    ];

    return <EcoTextTc className={`${css.comp} GtmModuleData-section`} data-section-id="TC" items={items} />;
};
export default TC;
